import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  RESET_ERROR,
  GET_ACCESS_SUCCESS,
  FETCH_MENU_SUCCESS
} from "./actionTypes"

const initialState = {
  error: null,
  loading: false,
  loginCheck: false,
  menu: null,
  access: null
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
        error: null
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        access: action.payload,
        loading: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state, menu: null }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case RESET_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_ACCESS_SUCCESS:
      state = { ...state, access: action.payload }
      break
    case FETCH_MENU_SUCCESS:
      state = { ...state, menu: action.payload }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
